export default "__VITE_ASSET__C1LyKaMa__"